import apiClient from './apiClient';
import type { ApiRequestOptions } from './apiClient';

export type ProfileReportCategory =
  | 'impersonation'
  | 'harassment'
  | 'inappropriate_content'
  | 'spam'
  | 'privacy_concern'
  | 'other';

export type AIReportCategory =
  | 'unsafe_or_offensive'
  | 'harassment_or_hate'
  | 'sexual_content'
  | 'self_harm'
  | 'misinformation'
  | 'privacy_concern'
  | 'other';

export interface SafetyReportAcknowledgement {
  id: string;
  event_id: string | null;
  subject_type: string;
  category: string;
  status: string;
  created_at: string;
  updated_at: string;
  already_reported: boolean;
}

export interface BlockedAttendee {
  user_id: string;
  created_at: string;
}

const blocksPath = (eventId: string) =>
  `/events/${encodeURIComponent(eventId)}/me/blocks`;

export const safetyService = {
  reportAI(
    receiptId: string,
    category: AIReportCategory,
    details: string,
    options: ApiRequestOptions = {},
  ): Promise<SafetyReportAcknowledgement> {
    return apiClient.post<SafetyReportAcknowledgement>(
      '/safety/reports/ai',
      { receipt_id: receiptId, category, details },
      options,
    );
  },

  reportProfile(
    eventId: string,
    userId: string,
    category: ProfileReportCategory,
    details: string,
    options: ApiRequestOptions = {},
  ): Promise<SafetyReportAcknowledgement> {
    return apiClient.post<SafetyReportAcknowledgement>(
      '/safety/reports/profile',
      {
        event_id: eventId,
        reported_user_id: userId,
        category,
        details,
      },
      options,
    );
  },

  listBlocks(eventId: string, options: ApiRequestOptions = {}): Promise<BlockedAttendee[]> {
    return apiClient.get<BlockedAttendee[]>(blocksPath(eventId), options);
  },

  blockUser(eventId: string, userId: string, options: ApiRequestOptions = {}): Promise<void> {
    return apiClient.put<void>(
      `${blocksPath(eventId)}/${encodeURIComponent(userId)}`,
      {},
      options,
    );
  },

  unblockUser(eventId: string, userId: string, options: ApiRequestOptions = {}): Promise<void> {
    return apiClient.delete<void>(
      `${blocksPath(eventId)}/${encodeURIComponent(userId)}`,
      options,
    );
  },
};
